const BUREAU_LABELS = {
  'SPC': 'SPC Brasil',
  'BOA_VISTA': 'Boa Vista',
  'CENPROT': 'Cenprot',
  'SERASA': 'Serasa',
};

export default function NegativationBlock({ status = {} }) {
  const bureaus = ['SPC', 'BOA_VISTA', 'CENPROT', 'SERASA'];
  const allCleared = bureaus.every(b => status[b] === 'cleared');

  return (
    <div data-testid="client-negativation-status">
      {allCleared && (
        <div className="mb-4 p-4 rounded-2xl bg-[rgba(0,255,163,0.08)] border border-[rgba(0,255,163,0.3)] text-center">
          <p className="text-lg font-display font-semibold text-[var(--rn-green)]">
            Seu CPF/CNPJ esta 100% regularizado.
          </p>
        </div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {bureaus.map((bureau) => {
          const isCleared = status[bureau] === 'cleared';
          return (
            <div
              key={bureau}
              data-testid={`client-bureau-status-${bureau.toLowerCase()}`}
              className={`rounded-xl p-4 text-center border ${
                isCleared
                  ? 'bg-[rgba(0,255,163,0.06)] border-[rgba(0,255,163,0.25)]'
                  : 'bg-white/[0.03] border-white/10'
              }`}
            >
              <p className="text-sm font-medium text-white/90 mb-2">{BUREAU_LABELS[bureau]}</p>
              {isCleared ? (
                <span className="badge-success">Baixado</span>
              ) : (
                <span className="badge-warning">Aguardando</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
